import { Stars } from "./sceneHoliday";

const G = 150;
const rnd = (i, k) => { const x = Math.sin(i * 12.9898 + k * 78.233) * 43758.5453; return x - Math.floor(x); };

export const WX_SKY = {
  cloud: { sky: ["#9FB4C8", "#C3D0DC", "#E2E8EE"], cloud: "#F4F6F9" },
  rain: { sky: ["#6F7D8E", "#98A4B2", "#C2CAD3"], cloud: "#C9D0D8" },
  snow: { sky: ["#B3C1D2", "#D4DDE8", "#EEF2F6"], cloud: "#F7F9FB" },
  night: { sky: ["#0B1433", "#24346A", "#55649C"], cloud: "#3A4A7E" },
  fog: { sky: ["#B9C2CB", "#D3D9DF", "#E8ECEF"], cloud: "#EEF1F4" },
};

// Map a station condition (+ temperature) to the scene's live weather.
export const wxOf = (condition = "", tempF) => {
  const c = condition.toLowerCase();
  if (/rain|hail|drizzle|storm|snow|sleet/.test(c)) return tempF != null && tempF <= 33 ? "snow" : "rain";
  if (/night/.test(c)) return "night";
  if (/fog|mist|haze/.test(c)) return "fog";
  if (/cloud|overcast/.test(c)) return /partly/.test(c) ? "partly" : "cloud";
  return "sun";
};

export function WeatherSky({ wx, top }) {
  if (wx !== "night") return null;
  const y = top + 0.28 * (G - top);
  return (
    <g data-testid="scene-wx-night">
      <Stars top={top} />
      <circle cx="250" cy={y} r="22" fill="#FFE7A8" opacity="0.16" /><circle cx="250" cy={y} r="11" fill="#FFF1C4" /><circle cx="254" cy={y - 3} r="9.5" fill="#24346A" opacity="0.92" />
    </g>
  );
}

export function WeatherFront({ wx, top, reduce }) {
  const span = G - top + 10;
  if (wx === "rain") return (
    <g data-testid="scene-wx-rain" stroke="#E6F0FF" strokeOpacity="0.75" strokeWidth="0.9" strokeLinecap="round">
      {Array.from({ length: 70 }, (_, i) => {
        const x = -340 + rnd(i, 1) * 800, y = top + rnd(i, 2) * span, d = 0.7 + rnd(i, 3) * 0.5;
        return <path key={i} d={`M${x} ${y} l-2 7`}>{!reduce && <animateTransform attributeName="transform" type="translate" values={`0 ${-span};-8 0`} dur={`${d}s`} begin={`-${rnd(i, 4) * d}s`} repeatCount="indefinite" />}</path>;
      })}
    </g>
  );
  if (wx === "snow") return (
    <g data-testid="scene-wx-snow" fill="#fff">
      {Array.from({ length: 60 }, (_, i) => {
        const x = -340 + rnd(i, 1) * 800, y = top + rnd(i, 2) * span, d = 6 + rnd(i, 3) * 5;
        return <circle key={i} cx={x} cy={y} r={0.7 + rnd(i, 5) * 1.1} opacity={0.7 + rnd(i, 6) * 0.3}>{!reduce && <animateTransform attributeName="transform" type="translate" values={`0 ${-span};${(rnd(i, 7) - 0.5) * 24} 0`} dur={`${d}s`} begin={`-${rnd(i, 4) * d}s`} repeatCount="indefinite" />}</circle>;
      })}
    </g>
  );
  if (wx === "fog") return (
    <g data-testid="scene-wx-fog" fill="#fff">
      {[0.55, 0.75, 0.9].map((f, i) => <rect key={i} x="-400" y={top + f * (G - top) - 6} width="900" height="12" rx="6" opacity={0.35 - i * 0.06}>{!reduce && <animateTransform attributeName="transform" type="translate" values={`0 0;${i % 2 ? -30 : 30} 0;0 0`} dur={`${18 + i * 6}s`} repeatCount="indefinite" />}</rect>)}
    </g>
  );
  return null;
}
